import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";

import axios from "axios";
import swal from "sweetalert";
// import './AddSessionTextEditor.css';

import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import moment from "moment";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./StarContent.css";

import ReactPlayer from "react-player";
import { serverInfo } from "../../../../App";
import { useContext } from "react";
import useFileHandleS3 from "../../../../CustomHooks/useFileHandleS3";
import MediaUploadProgressBar from "../../../../Screen/MediaUploadProgressBar";

export default function StarEditQna(props) {
  const { imageCdnUrl } = useContext(serverInfo);

  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [inputFieldList, setInputFieldList] = useState([
    {
      title: "",
      description: "",
      // event_date: "",
      // start_time: "",
      // end_time: "",
      star_availability_start_date: "",
      star_availability_end_date: "",
      total_minutes: "",
      fee: "",
      star_id: "",
      image: "",
    },
  ]);

  const handleRemoveClick = (index) => {
    const fieldList = [...inputFieldList];
    fieldList.splice(index, 1);
    setInputFieldList(fieldList);
  };

  // Editor Funtionalities //
  const [convertedContent, setConvertedContent] = useState();
  // Editor Funtionalities //
  const [instruction, setInstruction] = useState();
  const [starList, setStarList] = useState([]);

  // File Handle
  const fileInputRef = useRef(null);
  const [filePath, setFilePath] = useState("");
  const [file, setFile] = useState("");
  const [delKey, setDelKey] = useState(null);
  const [fileUrl,fileKey,progress] = useFileHandleS3(file,'qna/images',delKey);

  const [registerInput, setRegister] = useState({
    id: "",
    title: "",
    description: "",
    instruction: "",
    // event_date: "",
    // start_time: "",
    // end_time: "",
    min_time: "",
    max_time: "",
    // time_interval: "",
    // question_quantity: "",
    star_availability_start_date: "",
    star_availability_end_date: "",
    total_minutes: "",
    fee: "",
    star_id: "",
    registration_start_date: "",
    registration_end_date: "",
    error_list: [],
  });

  const handleInput = (e) => {
    const { name, value } = e.target;
    setRegister((prev) => {
      return { ...prev, [name]: value };
    });
    e.persist();
    setRegister({ ...registerInput, [e.target.name]: e.target.value });
  };

  // Fetch Stars Added By Admin
  // useEffect(() => {
  //   axios.get(`/api/admin/star_list`).then((res) => {
  //     if (res.status === 200) {
  //       setStarList(res.data.star);
  //     }
  //   });
  // }, []);

  const handleChange = (file) => {
    setDelKey(fileKey);
    setFile(file[0]);
  };
  const deleteFile = ()=>
  {
    setFile(null);
    setDelKey(fileKey);
    fileInputRef.current.value = '';

  }

  const registerSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const fData = new FormData();

    fData.append("image", fileKey?fileKey:filePath);
    fData.append("title", registerInput.title);
    // fData.append("star_id", registerInput.star_id);
    fData.append("instruction", instruction);
    fData.append("description", convertedContent);
    // fData.append("event_date", registerInput.event_date);
    // fData.append("start_time", registerInput.start_time);
    // fData.append("end_time", registerInput.end_time);
    fData.append(
      "star_availability_start_date", registerInput.star_availability_start_date
    );
    fData.append(
      "star_availability_end_date", registerInput.star_availability_end_date
    );
    fData.append(
      "registration_start_date",
      registerInput.registration_start_date
    );
    fData.append("registration_end_date", registerInput.registration_end_date);
    fData.append("fee", registerInput.fee);
    fData.append("min_time", registerInput.min_time);
    fData.append("max_time", registerInput.max_time);
    // fData.append("time_interval", registerInput.time_interval);
    // fData.append("question_quantity", registerInput.question_quantity);
    fData.append("total_minutes", registerInput.total_minutes);
    fData.append("id", registerInput.id);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/star/update_Qna`, fData).then((res) => {
        setLoading(false);
        if (res.data.status === 200) {
          if(file){
            setFile('');
            setDelKey(filePath.split("com/").pop())
          }
          swal("Success", res.data.message, "success");

          history.goBack()
        } else {
          //setModalShow(true);
          setRegister({
            ...registerInput,
            error_list: res.data.validation_errors,
          });
        }
      });
    });
  };

  useEffect(() => {
    let isMounted = true;

    const event_id = props.match.params.id;

    axios.get(`/api/star/qna_details/${event_id}`).then((res) => {
      if (isMounted) {
        if (res.data.status === 200) {
          setRegister(res.data.event);
          setFilePath(res.data.event?.banner);
        }
      }
    });
  }, [props.match.params.slug, history]);

  return (
    <>
      <div
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div className="text-light border border-warning rounded-3 d-flex justify-content-center p-2 mb-3">
          <div className="faTrophy">
            <i className="fa-solid fa-calendar-plus"></i>
          </div>
          <h4 className="mx-3 text-warning p-2">
            Edit Question And Answers Event
          </h4>
        </div>
        <div className="Modal-js-body">
          <div className="container-lg">
            <div className="row">
              <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                <form
                  className="p-3"
                  onSubmit={registerSubmit}
                  id="input_form"
                  encType="multipart/form-data"
                >
                  <div className="form-group row my-4">
                    <label className="col-sm-3 label-text ">Event Title</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control reply-control"
                        placeholder="Input title.."
                        onChange={handleInput}
                        name="title"
                        value={registerInput.title}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.title}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row my-4">
                    <label className="col-sm-3 label-text ">Description</label>
                    <div className="col-sm-9">
                      <CKEditor
                        name="description"
                        data={registerInput.description}
                        editor={ClassicEditor}
                        onChange={(event, editor) => {
                          setConvertedContent(editor.getData());
                        }}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.description}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row my-4">
                    <label className="col-sm-3 label-text ">Instruction</label>
                    <div className="col-sm-9">
                      <CKEditor
                        name="instruction"
                        data={registerInput.instruction}
                        editor={ClassicEditor}
                        onChange={(event, editor) => {
                          setInstruction(editor.getData());
                        }}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.instruction}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row my-3">
                    <label className="col-sm-3 label-text ">Banner</label>
                    <div className="col-sm-5 file-x-i">
                    {fileUrl && file ? (
                           <div className="position-relative">
                    
                           <img
                           src={fileUrl}
                           className="img-fluid avatar-img-src"
                           alt=""
                           style={{ maxHeight: "300px" }}
                         />  
                        <span className="text-warning right-cross-button" onClick={deleteFile}>X</span>
                         </div>
                      ) : (
                        <img
                          src={imageCdnUrl + filePath}
                          className="img-fluid avatar-img-src"
                          alt=""
                          style={{ maxHeight: "300px" }}
                        />
                      )}
                      <input
                        type="file"
                        accept="image/*"
                        className="form-control reply-control"
                        onChange={(e) => handleChange(e.target.files)}
                        id="image"
                        name="image"
                        ref={fileInputRef}
                      />
                     {file && !fileUrl && <MediaUploadProgressBar progress={progress} />}
                      <span className="text-danger">
                        <span className="text-danger">
                          {registerInput.error_list?.image}
                        </span>
                      </span>
                    </div>
                  </div>

                  {/* <div className="form-group row my-4">
                    <label className="col-sm-3 label-text ">Event Date</label>
                    <div className="col-sm-5">
                      <input
                        type="date"
                        className="form-control reply-controlDate"
                        onChange={handleInput}
                        name="event_date"
                        value={moment(registerInput.event_date).format(
                          "YYYY-MM-DD"
                        )}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.event_date}
                      </span>
                    </div>
                  </div> */}

                  {/* <div className="form-group row my-3 text-warning">
                    <label className="col-md-3 label-text ">Event Time</label>
                    <div className="col-sm-3">
                      <input
                        type="time"
                        className="form-control reply-controlDate"
                        onChange={handleInput}
                        name="start_time"
                        value={registerInput.start_time}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.start_time}
                      </span>
                    </div>{" "}
                    To
                    <div className="col-sm-3">
                      <input
                        type="time"
                        className="form-control reply-controlDate"
                        onChange={handleInput}
                        name="end_time"
                        value={registerInput.end_time}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.end_time}
                      </span>
                    </div>
                  </div> */}
                  <div className="form-group row my-3 text-warning">
                    <label className="col-sm-3 label-text ">
                      Avalability Start
                    </label>
                    <div className="col-sm-3">
                      <input
                        type="date"
                        className="form-control reply-controlDate"
                        onChange={handleInput}
                        name="star_availability_start_date"
                        value={moment(
                          registerInput.star_availability_start_date
                        ).format("YYYY-MM-DD")}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.star_availability_start_date}
                      </span>
                    </div>{" "}
                    To
                    <div className="col-sm-3">
                      <input
                        type="date"
                        className="form-control reply-controlDate"
                        onChange={handleInput}
                        name="star_availability_end_date"
                        value={moment(
                          registerInput.star_availability_end_date
                        ).format("YYYY-MM-DD")}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.star_availability_end_date}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row my-3 text-warning">
                    <label className="col-sm-3 label-text ">
                      Registration Start
                    </label>
                    <div className="col-sm-4">
                      <input
                        type="date"
                        className="form-control reply-controlDate"
                        onChange={handleInput}
                        name="registration_start_date"
                        value={moment(
                          registerInput.registration_start_date
                        ).format("YYYY-MM-DD")}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.registration_start_date}
                      </span>
                    </div>{" "}
                    To
                    <div className="col-sm-4">
                      <input
                        type="date"
                        className="form-control reply-controlDate"
                        onChange={handleInput}
                        name="registration_end_date"
                        value={moment(
                          registerInput.registration_end_date
                        ).format("YYYY-MM-DD")}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.registration_end_date}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row my-3">
                    <label className="col-sm-3 label-text ">
                      Minimum Question Time
                    </label>
                    <div className="col-sm-5">
                      <input
                        type="number"
                        min={0}
                        className="form-control reply-control"
                        placeholder="00"
                        onChange={handleInput}
                        name="min_time"
                        value={registerInput.min_time}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.min_time}
                      </span>
                    </div>
                  </div>
                  <div className="form-group row my-3">
                    <label className="col-sm-3 label-text ">
                      Maximum Question Time
                    </label>
                    <div className="col-sm-5">
                      <input
                        type="number"
                        min={0}
                        className="form-control reply-control"
                        placeholder="00"
                        onChange={handleInput}
                        name="max_time"
                        value={registerInput.max_time}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.max_time}
                      </span>
                    </div>
                  </div>
                  {/* <div className="form-group row my-3">
                    <label className="col-sm-2 label-text ">
                      Question Quantity
                    </label>
                    <div className="col-sm-3">
                      <input
                        type="text"
                        className="form-control reply-control"
                        placeholder="00"
                        onChange={handleInput}
                        name="question_quantity"
                        value={registerInput.question_quantity}
                      />
                      <span className="text-danger">
                          {registerInput.error_list?.question_quantity}
                        </span>
                    </div>
                  </div> */}

                  {/* <div className="form-group row my-3">
                    <label className="col-sm-3 label-text ">
                      Time Interval
                    </label>
                    <div className="col-sm-5">
                      <input
                        type="number"
                        min={0}
                        className="form-control reply-control"
                        placeholder="00"
                        onChange={handleInput}
                        name="time_interval"
                        value={registerInput.time_interval}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.time_interval}
                      </span>
                    </div>
                  </div> */}

                  <div className="form-group row my-3">
                    <label className="col-sm-3 label-text ">
                      Total User Speaking Time
                    </label>
                    <div className="col-sm-5">
                      <input
                        type="number"
                        min={0}
                        className="form-control reply-control"
                        placeholder="Enter total minutes"
                        onChange={handleInput}
                        name="total_minutes"
                        value={registerInput.total_minutes}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.total_minutes}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row my-3">
                    <label className="col-sm-3 label-text ">
                      Fee Per Minute
                    </label>
                    <div className="col-sm-5">
                      <input
                        type="number"
                        min={0}
                        className="form-control reply-control"
                        placeholder="00"
                        onChange={handleInput}
                        name="fee"
                        value={registerInput.fee}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.fee}
                      </span>
                    </div>
                  </div>

                  {/* Update Submit */}
                  <div className="row justify-content-center aligns-items-center my-4 mt-5">
                    <div className="col-md-3"></div>
                    <div className="col-md-9 d-flex justify-content-center aligns-items-center">
                      {/* <Link to={`/superstar/post/${params.id}`}>
                        <button className="btn btnGoBack fw-bold" type="submit">
                          Go Back
                        </button>
                      </Link> */}
                      {loading ? (
                        <>
                          <button className="btn btnUpdate">
                            <i className="fas fa-spinner fa-pulse"></i>{" "}
                          </button>
                        </>
                      ) : (
                        <button className="btn btnUpdate fw-bold" type="submit">
                          Update
                        </button>
                      )}
                    </div>
                  </div>
                  {/* Update Submit End */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
